/**
 * @require framework/shared/jquery-1.8.3.js
 *
 * @file    depage-gallery.js
 *
 * adds a custom gallery
 *
 *
 * copyright (c) 2017-2018 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 **/

import $ from 'jquery';

import '@accessible360/accessible-slick';

;(function($){
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    if(!$.depage){
        $.depage = {};
    }

    $.depage.gallery = function(el, options){
        // {{{ variables
        // To avoid scope issues, use 'base' instead of 'this' to reference this class from internal events and functions.
        var base = this;

        // Access to jQuery and DOM versions of element
        base.$el = $(el);
        base.el = el;

        if (base.$el.data("depage.gallery") !== undefined) {
            // test if this is already a gallery object
            // @todo remove and re-add gallery when called with different options
            return;
        }

        // Add a reverse reference to the DOM object
        base.$el.data("depage.gallery", base);

        var $links,
            $overlay,
            $inner,
            $view,
            $nav,
            $img,
            $close;

        base.num = 0;
        base.visible = false;
        // }}}

        // {{{ init()
        base.init = function(){
            base.options = $.extend({},$.depage.gallery.defaultOptions, options);

            $links = base.$el.find("a");

            $links.each(function(i) {
                $(this).on("click", function() {
                    return base.show(i);
                });
            });

            base.num = $links.length;
        };
        // }}}
        // {{{ getNavSlidesToShow()
        base.getNavSlidesToShow = function() {
            var slidesToShow = Math.floor(window.innerWidth / base.options.thumbWidth);

            if (slidesToShow > base.num) {
                slidesToShow = base.num;
            }

            return slidesToShow;
        };
        // }}}
        // {{{ getNavCenterMode()
        base.getNavCenterMode = function(toShow) {
            if (toShow < base.num) {
                $nav.find(".slick-track").css("max-width", "none");
                $nav.removeClass("slick-centered");
            } else {
                $nav.find(".slick-track").css("max-width", (base.options.thumbWidth * base.num) + "px");
                $nav.addClass("slick-centered");
            }
            return true;
        }
        // }}}

        // {{{ createViewSlide()
        base.createViewSlide = function(imgSrc, title, copyright) {
            var $slide = $("<figure class=\"slide\"/>");

            $("<img/>").attr("data-lazy", imgSrc).appendTo($slide);

            if (title + copyright !== "") {
                var $caption = $("<figcaption/>").appendTo($slide);
                $("<p class=\"title\"></p>").text(title).appendTo($caption);
                $("<p class=\"copyright\"></p>").text(copyright).appendTo($caption);
            }

            $slide.appendTo($view);

            return $slide;
        };
        // }}}
        // {{{ createNavSlide()
        base.createNavSlide = function(imgSrc, index) {
            var $slide = $("<figure class=\"thumb\"/>").on("click", function() {
                base.goTo(index);
            });

            $("<img/>").attr("src", imgSrc).appendTo($slide);

            $slide.appendTo($nav);

            return $slide;
        };
        // }}}

        // {{{ show()
        base.show = function(n) {
            if (n >= base.num) {
                n = 0;
            } else if (n < 0) {
                n = base.num - 1;
            }

            $overlay = $("<dialog class=\"" + base.options.overlayClass + " visible\" aria-modal=\"true\"></dialog>").appendTo(base.options.overlayAppendTo);
            $inner = $("<div class=\"inner\"/>").appendTo($overlay);

            $view = $("<div class=\"" + base.options.overlayClass + "-view\"></div>").appendTo($inner);
            $nav = $("<div class=\"" + base.options.overlayClass + "-nav\"></div>").appendTo($inner);

            $img = $("<img/>").appendTo($inner);
            base.$oldfocus = $(document.activeElement);
            $close = $("<button class=\"slick-close\">close</button>").appendTo($overlay).focus();

            $links.each(function(i) {
                var $link = $(this);

                base.createViewSlide($link.attr("href"), $link.data("title") || "", $link.data("copyright") || "");
                base.createNavSlide($link.children("img").attr("src"), i);
            });

             $view.slick({
                lazyLoad: 'ondemand',
                initialSlide: n,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                swipe: false,
                fade: true,
                dots: false,
                asNavFor: "." + base.options.overlayClass + "-nav",
            });
            var toShow = base.getNavSlidesToShow();
            $nav.slick({
                centerPadding: 0,
                infinite: false,
                slidesToScroll: 1,
                asNavFor: "." + base.options.overlayClass + "-view",
                arrows: true,
                dots: false,
            });
            $(window).on("resize", function() {
                var toShow = base.getNavSlidesToShow();

                $nav.slick("slickSetOption", "centerMode", base.getNavCenterMode(toShow), false);
                $nav.slick("slickSetOption", "slidesToShow", toShow, true);
                $nav.slick("slickGoTo", $view.slick("slickCurrentSlide"));
            });
            $close.on("click", function() {
                return base.hide();
            });
            $(window).on("keyup.depage-gallery", function(e) {
                if (!base.visible) return;

                var code = e.which;

                if (code == 37) {
                    // arrow left
                    base.prev();
                } else if (code == 39) {
                    // arrow right
                    base.next();
                } else if (code == 27) {
                    // escape cape
                    base.hide();
                }
            });

            setTimeout(function() {
                base.goTo(n);
                base.visible = true;
            }, 20);

            return false;
        };
        // }}}
        // {{{ hide()
        base.hide = function() {
            $overlay.removeClass("visible");
            base.visible = false;

            $(window).off("keyup.depage-gallery");
            $(window).off("resize");

            $view.slick("unslick");
            $nav.slick("unslick");

            $overlay.remove();

            if (base.$oldfocus) {
                base.$oldfocus.focus();
            }

            return false;
        };
        // }}}
        // {{{ next()
        base.next = function() {
            $view.slick("slickNext");
        };
        // }}}
        // {{{ prev()
        base.prev = function() {
            $view.slick("slickPrev");
        };
        // }}}
        // {{{ goTo()
        base.goTo = function(n) {
            var toShow = base.getNavSlidesToShow();

            $nav.slick("slickSetOption", "centerMode", base.getNavCenterMode(toShow), false);
            $nav.slick("slickSetOption", "slidesToShow", toShow, true);

            $view.slick("slickGoTo", n);
            $nav.slick("slickGoTo", n);
        };
        // }}}

        // Run initializer
        base.init();
    };

    // {{{ defaultOptions()
    $.depage.gallery.defaultOptions = {
        overlayClass: "gallery-overlay",
        overlayAppendTo: "body",
        thumbWidth: 90
    };
    // }}}

    // {{{ $.fn.depageGallery()
    $.fn.depageGallery = function(options){
        return this.each(function(){
            (new $.depage.gallery(this, options));
        });
    };
    // }}}
})($);

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
